import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.759 15.114a1 1 0 0 1-1.519 0l-3.826-4.463A1 1 0 0 1 8.174 9h7.652a1 1 0 0 1 .759 1.651Z"
    }, null, -1)
  ])))
}
export default { render: render }